<template>
    <Row type="flex" :gutter="10" :justify="justify" align="middle"> 
        <Col v-for="(item,index) in btnItems" v-if="item.visible">
           <Button :type="item.type" :icon="item.icon" v-if="!moreFlag || index < myConfig.showNum" :custom-icon="item.customIcon" :size="item.size" @click="action(item.name)" :disabled="item.readOnly" :ghost="item.name == 'backData' || item.name == 'preBill' || item.name == 'nextBill'">{{item.text}}</Button>
           <Divider type="vertical" v-if="item.name == 'nextBill' && item.visible" style="margin: 0 0 0 5px;height: 20px"/>
        </Col>
        <Col v-if="moreFlag">
            <Dropdown>
                <a href="javascript:void(0)" style="color: #515a6e">
                    更多操作
                    <Icon type="ios-arrow-down"></Icon>
                </a>
                <DropdownMenu slot="list">
                     <DropdownItem v-for="(item,index) in btnItems"  v-if="index >= myConfig.showNum && item.visible" :disabled="item.readOnly">
                          <Button :type="item.type" :icon="item.icon" :custom-icon="item.customIcon" :size="item.size" @click="action(item.name)" :disabled="item.readOnly">{{item.text}}</Button>
                     </DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </Col>
    </Row>
</template>

<script>
export default {
    name:'buttontoolBar',
    data () {
        return {
            myConfig:{
                size:'default',
                showNum:10,
                enablePermissions:true,
                items:[]
            },
            moreFlag:false,
            btnItems:[],
            apporval:[{
                name:'submitData',
                text:'提交'
            },{
                name:'revokeData',
                text:'撤回'
            },{
                name:'approveData',
                text:'审批'
            }]
        };
    },
    props:{
        config: {
            type:Object,
            default:null
        },
        moduleMethod:{
            type:Array,
            default: () => {
                return [];      
            }
        },
        ignoreModule:{
            type:Array,
            default:() => {
                return [];
            }
        },
        justify:{
            type:String,
            default:'center'
        },
        modeType:{
            type:String,
            default:'details'
        }
    },
    created () {
        this.init();
    },
    methods: {
        init () {
            let moduleMethod = this.$Method.copy(this.moduleMethod);
            this.myConfig =  Object.assign({},this.myConfig, this.config);
            // 处理按钮
            if (this.myConfig.enablePermissions) {
                if (moduleMethod && moduleMethod.length > 0) {
                    moduleMethod.forEach(el => {
                        let btnConfig = Object.assign({}, {}, el);
                        if (this.myConfig.items && this.myConfig.items.length > 0) {
                            let tempConfig = this.myConfig.items.find(el2 => el.name === el2.name);
                            if (tempConfig) {
                                Object.assign(btnConfig,tempConfig);
                                let index = this.btnItems.findIndex(el3 => el3.name === btnConfig.name);
                                if (index === -1) {
                                    this.btnItems.push(this.initButton(btnConfig));
                                }
                              
                            }
                        }
                    });
                } 
            } else {
                if (this.myConfig.items && this.myConfig.items.length > 0) {
                    this.myConfig.items.forEach(el => {
                        this.btnItems.push(this.initButton(el));
                    });
                }
            }
            if (this.myConfig.billisworkflow && this.myConfig.billisworkflow.startsWith('Y')) {
                this.apporval.forEach(el => {
                    this.btnItems.push(this.initButton(el));
                });
            }
            if (this.btnItems.length > this.myConfig.showNum + 1){
                this.moreFlag = true;
            }
        },
        action(name) {
            let obj = {};
            obj.name = name;
            this.$emit('doAction', obj);
        },
        initButton (config) {
            if (config.iconcls) {
                if (config.iconcls.indexOf('_') === 0) {
                    config.customIcon = 'iconfont icon-' + config.iconcls.substring(1, config.iconcls.length);
                } else {
                    config.icon = config.iconcls;
                }
            }
            if (!config.size) {
                config.size = this.myConfig.size;
            }
            if (config.readOnly === undefined) {
                config.readOnly = false;
            }
            if (config.visible === undefined) {
                config.visible = true;
            }
            if (config.type === undefined) {
                config.type = 'primary';
            }
            return config;
        },
        doCommonPro (btnName, proName, value,flag) {
            if (!flag) {
                if (this.ignoreModule.length > 0) {
                    let index2 = this.ignoreModule.findIndex(el => el === btnName);
                    if (index2 > -1) {
                        return false;
                    }
                }
            }
            let index = this.btnItems.findIndex(el => el.name === btnName);
            if (index > -1) {
                let pro = {};
                pro[proName] = value;
                let temp = Object.assign({},this.btnItems[index], pro);
                this.btnItems.splice(index,1,temp);
            }
        },
        setAllReadOnly (value) {
            let btn = this.$Method.copy(this.btnItems);
            btn.forEach(el => {
                this.doCommonPro(el.name,'readOnly', value);
            });
        },
        setReadOnly (obj, value) {
            if (obj) {
                if (obj instanceof Array) {
                    obj.forEach(el => {
                        this.doCommonPro(el,'readOnly', value);
                    });
                } else {
                    this.doCommonPro(obj,'readOnly', value);
                }
            }
        },
        setVisible (obj, value) {
            if (obj) {
                if (obj instanceof Array) {
                    obj.forEach(el => {
                        this.doCommonPro(el,'visible', value,true);
                    });
                } else {
                    this.doCommonPro(obj,'visible', value, true);
                }
            }
        },
        getBtnConfig (value) {
            let index = this.btnItems.findIndex(el => el.name === value);
            if (index > -1) {
                return this.$Method.copy(this.btnItems[index]);
            } else {
                return '';
            }
        },
        addBtnConfig (index, config) {
            let tmp = this.initButton(config);
            this.btnItems.splice(index,1,tmp);
        },
        getData() {
            return this.$Method.copy(this.btnItems);
        },
        // front back
        addBtnObject(configObject, position) {
            let result = [];
            if (configObject) {
                configObject.forEach(el => {
                    result.push(this.initButton(el));
                    let index = this.btnItems.findIndex(el2 => el2.name === el.name);
                    if (index > -1) {
                        this.btnItems.splice(index,1);
                    }
                });
            }
            if (result.length > 0) {
                if (position === 'front') {
                    this.btnItems = result.concat(this.btnItems);
                }
                if (position === 'back') {
                    this.btnItems = this.btnItems.concat(result);
                }
            }
           
        }
    }

};
</script>



// WEBPACK FOOTER //
// src/components/layouttemplate/btntoolbar.vue